module.exports = __webpack_public_path__ + "img/depthMap-pandemonium230.9e62a066.png";